var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Approved",
    "data-name": "Icon - Approved",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1945",
    "data-name": "Group 1945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z",
    fill: "#d4e507"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz24",
    d: "M87.74-866.86l6.345-6.345-1.26-1.26L87.74-869.38l-2.565-2.565-1.26,1.26ZM89-862a8.765,8.765,0,0,1-3.51-.709,9.093,9.093,0,0,1-2.857-1.924,9.088,9.088,0,0,1-1.924-2.858A8.763,8.763,0,0,1,80-871a8.764,8.764,0,0,1,.709-3.51,9.088,9.088,0,0,1,1.924-2.857,9.086,9.086,0,0,1,2.857-1.924A8.762,8.762,0,0,1,89-880a8.762,8.762,0,0,1,3.51.709,9.086,9.086,0,0,1,2.858,1.924,9.088,9.088,0,0,1,1.924,2.857A8.764,8.764,0,0,1,98-871a8.763,8.763,0,0,1-.709,3.51,9.088,9.088,0,0,1-1.924,2.858,9.093,9.093,0,0,1-2.858,1.924A8.765,8.765,0,0,1,89-862Zm0-1.8a6.949,6.949,0,0,0,5.107-2.093A6.949,6.949,0,0,0,96.2-871a6.949,6.949,0,0,0-2.093-5.107A6.949,6.949,0,0,0,89-878.2a6.949,6.949,0,0,0-5.108,2.093A6.949,6.949,0,0,0,81.8-871a6.949,6.949,0,0,0,2.092,5.107A6.949,6.949,0,0,0,89-863.8ZM89-871Z",
    transform: "translate(-71 889)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.d5cc47e8a618cd7c8a499684e533560c.svg";
export { ForwardRef as ReactComponent };